import { reportErrorNow } from '@ms/yammer-telemetry';
import type { AuthenticatorOptions } from '@ms/yammer-web-authenticators';
import { AcquireTokenAuthError, SsoSilentError } from '@ms/yammer-web-authenticators';

export const reportAuthError: AuthenticatorOptions['onError'] = async (error, { authenticatorType, scopes }) => {
  const eventProperties = {
    authenticatorType,
    skipAuthentication: true,
    ...(scopes ? { scopes: scopes.join(',') } : null),
  };

  if (error instanceof AcquireTokenAuthError) {
    await reportErrorNow({
      error,
      eventProperties: {
        ...eventProperties,
        errorCode: 'AuthAcquireTokenSilentFailed',
      },
    });
  }

  if (error instanceof SsoSilentError) {
    await reportErrorNow({
      error,
      eventProperties: {
        ...eventProperties,
        errorCode: 'SSOSilentAuthError',
      },
    });
  }
};
